// extracted by mini-css-extract-plugin
export default {"background":"HomePageBox_background__27fcs","background2":"HomePageBox_background2__4i29f"};